/* global axios */
import ApiClient from './ApiClient';

class ChatbotFlowsAPI extends ApiClient {
  constructor() {
    super('chatbot_flows', { accountScoped: true });
  }

  clone(flowId) {
    return axios.post(`${this.url}/${flowId}/clone`);
  }

  generate({ prompt, imageBase64, openaiApiKey }) {
    return axios.post(`${this.url}/generate`, {
      prompt,
      image_base64: imageBase64,
      openai_api_key: openaiApiKey,
    });
  }
}

export default new ChatbotFlowsAPI();
